<template>
  <div class="school-list-page w mx-auto p-4">
    <h2 class="text-2xl font-bold mb-4">高考专业查询（按专业找院校）</h2>
    <div class="search-bar mb-4">
      <el-select
        v-model="educationType"
        placeholder="请选择教育类型"
        class="mr-4"
      >
        <el-option label="本科(普通教育)" value="undergraduate"></el-option>
        <el-option label="专科(高等职业教育)" value="vocational"></el-option>
      </el-select>
      <el-input
        v-model="searchKeyword"
        placeholder="请输入专业名称"
        class="w-60 mr-4"
      ></el-input>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
    </div>
    <el-table :data="filteredSubjectList" stripe>
      <el-table-column
        prop="name"
        label="院校名称"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="province"
        label="省份"
        width="120"
      ></el-table-column>
      <el-table-column prop="major" label="专业名称"></el-table-column>
    </el-table>
    <el-button @click="goBack" class="mt-4">返回首页</el-button>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

// 初始数据
const subjectList = ref([
  { name: "北京大学", province: "北京", major: "计算机科学" },
  { name: "清华大学", province: "北京", major: "软件工程" },
  // 更多数据...
]);

const educationType = ref("undergraduate");
const searchKeyword = ref("");

// 根据搜索条件过滤数据
const filteredSubjectList = computed(() => {
  return subjectList.value.filter((item) =>
    item.major.includes(searchKeyword.value)
  );
});

const handleSearch = () => {
  // 可以在这里添加更多搜索逻辑，比如根据 [educationType](file://d:\qian-pro\node4\pro\vue3-pro\src\views\SubjectList.vue#L12-L12) 进行筛选
};

const goBack = () => {
  router.push({ name: "Home" }); // 返回首页
};
</script>

<style scoped>
.w {
  width: 1200px;
  margin: 0 auto;
}
.school-list-page {
  margin-top: 50px;
}

.el-table {
  margin-top: 20px;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.mr-4 {
  margin-right: 16px;
}

.w-60 {
  width: 300px;
}

/* 搜索框文字样式 */
.search-bar .el-input {
  padding: 0 12px;
  line-height: 40px;
  font-size: 14px;
  text-indent: 0;
}

/* 表格列标题样式 */
.el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-table-column {
  width: auto;
  min-width: 100px;
}
</style>
